import { AthenaTicketStatusWithPrefix } from '@/types/transaction-setting';

export interface ApiBackendInfo {
	url: string;
	token: string;
	isReady: boolean;
	isBefore: boolean;
}

export enum MenuTagEnum {
	New = 0,
	Hot = 1
}

export enum MenuOpenTypeEnum {
	Inner,
	Popup,
	ExecJsFunc,
	OpenSportsbook,
	OpenDropdown,
}

export enum MenuTemplateComponentEnum {
	/**
	 * 沙巴體育
	 */
	Sportsbook = 1,

	/**
	 * 輪播區塊
	 */
	Visual2 = 2,

	/**
	 * 自定義 iframe 區塊
	 */
	CustomBlock = 3,

	/**
	 * 預設格式的 footer
	 */
	Footer = 4,

	/**
	 * 自定義 iframe 的 footer
	 */
	CustomFooter = 5,

	/**
	 * LiveChat 小工具
	 */
	LiveChatWidget = 6,
}

export const MenuTagLabel: { [key in MenuTagEnum]: string } = {
	[MenuTagEnum.New]: 'new',
	[MenuTagEnum.Hot]: 'hot'
};


export interface AthenaMenuSetting {
	MainMenuList: MainMenuList[]
	Footer: MenuSetting
}

export interface MainMenuList extends MenuSetting {
	SubMenuList: MenuSetting[];
}

export interface MenuSetting {
	TabName: string
	Translation: string
	OpenType: MenuOpenTypeEnum
	OpenContent: string
	Size: string | null
	TemplateComponents: Array<MenuTemplateComponentEnum>
	Tag: MenuTagEnum | null | undefined
	Sort: number
}

export enum InputTypeEnums {
	Input = 'input',
	Dropdown = 'dropdown'
}

export interface BankDetailInfo extends BankInfo {
	DepositPending: DepositInfo[];
	ToAccountInfos: BankDetail[];
	WithdrawalPending: WithdrawalInfo[];
	Currency: string;
	SysT: string;
	showBankName: string;
	showCountry: string;
	showAddress: string;
	showAccount_Number: string;
	showSwift_Code: string;
	showCorresponding_Bank: string;
	showBranch: string;
	showAccountName: string;
	BankAccountNumberType: InputTypeEnums;
	showBankAccountNumber: string;
	ToAccountNumber: string;
	IsBankDetailComplete: boolean;
	remarkBankName: string;
	remarkBankAccountNumber: string;
	remarkBankBranch: string;
	remarkBankAddr: string;
	remarkBankCountry: string;
	remarkBankAccountName: string;
	remarkBankSWIFT: string;
	remarkCorrespondingBank: string;
	typeBankName: InputTypeEnums;
	typeBankAccountNumber: InputTypeEnums;
	typeBankBranch: InputTypeEnums;
	typeBankAddr: InputTypeEnums;
	typeBankCountry: InputTypeEnums;
	typeBankAccountName: InputTypeEnums;
	typeBankSWIFT: InputTypeEnums;
	typeCorrespondingBank: string;
	BankList: ListSetting[];
	CountryList: ListSetting[];
	CurrencyLimit: DepWitCurrLimit;
}

export interface MailingAddress {
	address: string;
	city: string;
	state: string;
	zipCode: string;
	phone: string;
} 

export interface BankInfo {
	BankName: string;
	Country: string;
	Address: string;
	City_Town: string;
	ZipCode: string;
	Account_Number: string;
	Swift_Code: string;
	Corresponding_Bank: string;
	Success: number;
	Branch: string;
	AccountName: string;
}

export interface BankDetail {
	BankDetailID: number;
	BankedIn: string;
}

export interface WithdrawalInfo {
	TansaactionID: string;
	Amount: number;
	ReferenceNo: string;
	Status: AthenaTicketStatusWithPrefix;
	RequestDate: string;
	LastModify: string;
	strRequestDate: string;
	strLastModify: string;
	WithdrawalId: number;
	Mode: string;
	ChargeFee: number;
	IBCTransID_Request: string;
	IBCTransIDCharge_Request: string;
}

export interface ListSetting {
	Text: string;
	Value: string;
	Group: string;
}

export interface DepWitCurrLimit {
	DepCurrMin: number;
	DepCurrMax: number;
	WitCurrMin: number;
	WitCurrMax: number;
}

export interface DepositInfo {
	TansaactionID: string;
	Amount: number;
	ReferenceNo: string;
	Status: AthenaTicketStatusWithPrefix;
	RequestDate: string;
	LastModify: string;
	strRequestDate: string;
	strLastModify: string;
	SendFlag: number;
	Mode: string;
}

export interface AthenaSiteConfig {
	DownloadAPPUrl: string;
	CanSeeONLiveCasino: boolean;
	CanSeeWECasino: boolean;
	CanSeeYeeBet: boolean;
	CanSeeAESexy: boolean;
	CanSeeAG: boolean;
	CanSeeAllBet: boolean;
	CanSeeFggLiveCasino: boolean;
	CanSeeVirtualGame: boolean;
	CanSeeCasino: boolean;
	CanSeeRngVB: boolean;
	CanSeeSAGaming: boolean;
	CanSeeWM: boolean;
	CanSeeBG: boolean;
	CanSeeKeno: boolean;
	CanSeeKenoLottery: boolean;
	CanSeeTableGame: boolean;
	CanSeeMaxGame: boolean;
	CanSeeLottoworld: boolean;
	CanSeeMicrogamingLive: boolean;
	CanSeePTLiveCasino: boolean;
	EnableWithdrawalCancel: boolean;
	CanSeeContactUs: boolean;
	LicenseeGAId: string;
}

export interface BankInfoModel {
	isOpenBankInfo: boolean;
	AskChangeBankInfo: string;
	canFixBankInfo: boolean;
	showBankName: string;
	BankNameType: string;
	remarkBankName: string;
	BankName: string;
	showBankAccountName: string;
	remarkBankAccountName: string;
	BankAccountName: string;
	showBankAccountNumber: string;
	remarkBankAccountNumber: string;
	BankAccountNumber: string;
	showBankBranch: string;
	remarkBankBranch: string;
	BankBranch: string;
	showBankAddr: string;
	remarkBankAddr: string;
	BankAddr: string;
	showBankCountry: string;
	BankCountryType: string;
	remarkBankCountry: string;
	BankCountry: string;
	showBankSWIFT: string;
	remarkBankSWIFT: string;
	BankSWIFT: string;
	showCorrespondingBank: string;
	remarkCorrespondingBank: string;
	CorrespondingBank: string;
	BankNameList: SelectListReact[];
	CountryList: SelectListReact[];
	Address: string;
	City: string;
	State: string;
	ZipCode: string;
	Mobile: string;
}
  
export interface SelectListReact {
	Value: string;
	Text: string;
}